export default {
    profile: 'โปรไฟล์',
    name: 'ชื่อ นามสกุล',
    employeeNo: 'รหัสพนักงาน',
    department: 'แผนก',
    group: 'กลุ่ม',
    startDate: 'วันเริ่ม',
    endDate: 'วันสิ้นสุด',
    status: 'สถานะการทำงาน',
    contact: 'ติดต่อ',
    email: 'อีเมล์',
    phoneNumber: 'เบอร์โทรศัพท์',
    checkInStatus: 'สถานะการเช็คชื่อ',
    date: 'วันที่',
    viewAttendance: 'ข้อมูลการลงเวลา',
    attachmentFile: 'ไฟล์แนบ',
    checkInDetail: 'รายละเอียดการลงเวลา',
    time: 'เวลา'
}
